<template>
  <a
    class="button-link"
    :title="linkName"
    :href="linkNameReformated"
    target="_blank"
  >
    <div
      ref="button"
      class="button-link__content h-v-centerer"
      :class="buttonClasses"
      :style="buttonStyle"
    >
      <img
        v-if="linkValue && showImage"
        class="button-link__image"
        :src="`https://www.google.com/s2/favicons?domain=${linkValue}`"
        :style="imageStyle"
      >
      {{ linkName }}
    </div>
  </a>
</template>

<script>
import { getTextFgColor } from '@/utils/main';
import mixinWidgets from '@/mixins/widgets.vue';
import mixinWidgetsBgColor from '@/mixins/widgets-bgcolor-config.vue';

const HEIGHT_ANIM_THRESHOLD = 1.5;

export default {
  name: 'ButtonLinkWidget',
  mixins: [mixinWidgets, mixinWidgetsBgColor],
  props: {
    linkValue: {
      type: String,
      default: '',
    },
    linkName: {
      type: String,
      default: '',
    },
    fontSize: {
      type: Number,
      default: 1,
    },
    imageSize: {
      type: Number,
      default: 16,
    },
    showImage: Boolean,
  },
  data() {
    return {
      buttonOffsetHeight: 0,
    };
  },
  computed: {
    linkNameReformated() {
      if (!/^(f|ht)tps?:\/\//i.test(this.linkValue)) {
        return `http://${this.linkValue}`;
      }
      return this.linkValue;
    },
    buttonClasses() {
      return {
        'border-animation': this.buttonOffsetHeight >= (HEIGHT_ANIM_THRESHOLD * 14 * this.fontSize),
      };
    },
    config() {
      return [
        {
          key: 'linkTopSeparator',
          value: '',
          component: 'Div',
          options: { class: 'filters-zone__modal__sep' },
        },
        {
          key: 'linkName',
          value: this.linkName,
          component: 'EditableLabel',
          options: {
            ref: 'label',
            id: `cfg-link-name${this.widget.id}`,
            useTextarea: true,
            legend: this.$t('message.TITLE'),
          },
        },
        {
          key: 'linkValue',
          value: this.linkValue,
          component: 'EditableLabel',
          options: {
            class: 'generic-field-margin',
            ref: 'label',
            id: `cfg-link-value${this.widget.id}`,
            useTextarea: true,
            legend: this.$t('message.WIDGET_BUTTON_LINK'),
          },
        },
        {
          key: 'fontSize',
          value: this.fontSize,
          component: 'PlusMinusButtons',
          options: {
            step: 0.1,
            legend: this.$t('message.WIDGET_TEXT_SIZE') + this.$t('message.TWO_DOTS'),
          },
        },
        {
          key: 'imageSize',
          value: this.imageSize,
          component: 'PlusMinusButtons',
          options: {
            min: 16,
            max: 20,
            step: 2,
            legend: this.$t('message.WIDGET_IMAGE_SIZE') + this.$t('message.TWO_DOTS'),
          },
        },
        {
          key: 'showImage',
          value: this.showImage,
          component: 'Checkbox',
          options: {
            value: this.showImage,
            title: this.$t('message.WIDGET_SHOW_ICON'),
          },
        },
        this.defaultBgColorConfig,
      ];
    },
    buttonStyle() {
      return {
        color: getTextFgColor(this.designOptions.bgColor),
        fontSize: `${this.fontSize}em`,
      };
    },
    imageStyle() {
      return this.widget.componentData
        ? { width: `${this.imageSize}px`, height: `${this.imageSize}px` }
        : { width: '16px', height: '16px' };
    },
  },
  mounted() {
    this.sizeChanged();
  },
  methods: {
    sizeChanged() {
      this.$nextTick(() => {
        this.buttonOffsetHeight = this.$refs.button.offsetHeight;
      });
    },
  },
};
</script>

<style lang='scss'>
.button-link {
  width: 100%;
  height: 100%;
  overflow: hidden;

  &__content {
    cursor: pointer;
    border-radius: 8px;
    width: 100%;
    height: 100%;
    transition: border 0.2s;
    box-sizing: border-box;
    border-color: transparent;

    &.border-animation:hover {
      border: 9px solid rgba(black, 0.2);
    }
  }
  &__image {
    padding-right: 15px;
  }
}
</style>
